"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
EventTarget.prototype.addDelegateListener = function addDelegateListener(type, selector, listener, options) {
    const listenerTarget = this;
    this.addEventListener(type, (event) => {
        const target = event.target;
        const delegateTarget = target.closest(selector);
        if (delegateTarget === null) {
            return;
        }
        const roleTarget = target.closest('[data-role]');
        let role = null;
        if (roleTarget !== null) {
            role = roleTarget.dataset.role;
        }
        listener({ target, delegateTarget, listenerTarget, event, role });
    }, options);
    return this;
};
//# sourceMappingURL=AddDelegateListener.js.map